<template>
  <div>
    <div v-if="!showSetPassword">
      <div class="text-center">
        <b-spinner v-if="!requestSent" variant="primary" label="Proszę czekać..."></b-spinner>
      </div>

      <b-alert
        v-model="emailValid"
        variant="success"
      >Twój adres email został potwierdzony i konto zostało aktywowane.</b-alert>

      <b-alert
        v-model="emailInvalid"
        variant="danger"
      >Wystąpił błąd i nie udało się potwierdzić Twojego adresu email.</b-alert>

      <b-alert v-model="showSetPasswordLink" variant="warning">
        Pamiętaj aby ustawić swoje pierwsze
        <span
          class="text-primary"
          style="cursor:pointer"
          @click="showSetPassword = true"
        >hasło</span>.
      </b-alert>

      <div class="text-right">
        <b-button variant="link" @click="goto('/public/login')">Wróć do strony logowania</b-button>
      </div>
    </div>
    <setPassword v-else :email="email" />
  </div>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import setPassword from "./SetPassword";

export default {
  data() {
    return {
      emailConfirmed: false,
      requestSent: false,
      showSetPassword: false,
      showSetPasswordLink: false
    };
  },
  components: {
    setPassword
  },
  computed: {
    emailValid() {
      return this.emailConfirmed && this.requestSent;
    },
    emailInvalid() {
      return !this.emailConfirmed && this.requestSent;
    }
  },
  props: {
    token: String,
    email: String
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    }
  },
  mounted() {
    axios
      .post("/auth/confirmEmail", {
        token: this.token,
        email: this.email
      })
      .then(response => {
        var result = response.data;

        this.showSetPasswordLink = !result.hasPassword;

        this.emailConfirmed = true;
      })
      .catch(error => eventBus.$emit("unhandled-error", error))
      .then(() => (this.requestSent = true));
  }
};
</script>

<style lang="scss" scoped>
.btn {
  &.btn-link {
    font-size: 0.75rem;
    text-decoration: none;
  }
}
</style>
